import { Action } from '../../../action';
import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setGetDailyList = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_FINANCE_OPERATION
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetDailyListAction({
                    list: data.data.list,
                    count: data.data.count,
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetDailyList as SetGetDailyList
}